<template>
  <div class="hardware-form">
    <a-card :title="title" :bordered="false">
      <a-form-model v-if="status===''" :model="form" ref="form" v-bind="formLayout" :rules="rules">
        <a-form-model-item label="串号" prop="serialNumber">
          <a-input v-model="form.serialNumber" placeholder="请输入串号" />
        </a-form-model-item>

        <a-form-model-item label="串号密钥" prop="serialCipher">
          <a-input v-model="form.serialCipher" placeholder="请输入串号密钥" />
        </a-form-model-item>

        <a-form-model-item v-if="operation==='bind'" label="硬件密文" prop="bindCipher">
          <a-input v-model="form.bindCipher" placeholder="请输入硬件密文" @keyup.enter="submit" />
        </a-form-model-item>

        <a-form-model-item v-if="operation==='unbind'" label="硬件密文" prop="unbindCipher">
          <a-input v-model="form.unbindCipher" placeholder="请输入硬件密文" @keyup.enter="submit" />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ offset: 2 }">
          <a-button type="primary" @click="submit">{{btnText}}</a-button>
        </a-form-model-item>
      </a-form-model>

      <a-result v-else :status="status" :title="`${btnText}${statusText}`" :sub-title="subTitle">
        <template #extra>
          <a-button @click="reload">再次{{btnText}}</a-button>
        </template>
      </a-result>
    </a-card>
  </div>
</template>

<script>
import { bindDevice, unbindDevice } from '../../../api/api'

const rules = {
  serialNumber: [
    { required: true, message: '请输入串号', trigger: 'blur' },
    { min: 1, max: 100, message: '最大长度100个字符', trigger: 'blur' }
  ],
  serialCipher: [
    { required: true, message: '请输入串号密钥', trigger: 'blur' },
    { min: 1, max: 100, message: '最大长度100个字符', trigger: 'blur' }
  ],
  bindCipher: [
    { required: true, message: '请输入硬件密文', trigger: 'blur' },
    { min: 16, max: 16, message: '长度必须16个字符', trigger: 'blur' }
  ],
  unbindCipher: [
    { required: true, message: '请输入硬件密文', trigger: 'blur' },
    { min: 16, max: 16, message: '长度必须16个字符', trigger: 'blur' }
  ]
}

const formLayout = {
  labelCol: { span: 2 },
  wrapperCol: { span: 8 }
}

export default {
  name: 'hardware-form',

  props: ['operation'],

  data() {
    return {
      formLayout,
      rules,

      form: {
        serialNumber: undefined,
        serialCipher: undefined,
        bindCipher: undefined,
        unbindCipher: undefined
      },

      status: '',
      subTitle: ''
    }
  },

  computed: {
    title() {
      return this.operation === 'bind' ? '绑定硬件' : '解绑硬件'
    },

    btnText() {
      return this.operation === 'bind' ? '绑定' : '解绑'
    },

    statusText() {
      return this.status === 'success' ? '成功' : '失败'
    }
  },

  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.status = ''
          if (this.operation === 'bind') {
            bindDevice(this.form).then(res => {
              if (res.error.code === 0) {
                this.status = 'success'
                this.subTitle = `授权码：${res.response.authorizationCode}`
              } else {
                this.status = 'error'
                this.subTitle = res.error.msg
              }
            })
          } else if (this.operation === 'unbind') {
            unbindDevice(this.form).then(res => {
              if (res.error.code === 0) {
                this.status = 'success'
              } else {
                this.status = 'error'
                this.subTitle = res.error.msg
              }
            })
          }
        }
      })
    },

    reload() {
      this.form = {
        serialNumber: undefined,
        serialCipher: undefined,
        bindCipher: undefined,
        unbindCipher: undefined
      }

      this.status = ''
    }
  }
}
</script>

